import { Studio } from "../auth/useStudio";
import { createSlice } from "@reduxjs/toolkit";
import { setDocumenti } from "../localStorage/localStorageApi";
import { USER_ROLE } from "../constants";
import { getLocalStorage } from "../localStorage/createPrefixedLocalStorage";


export const initializeDocumentsLocalStorage = (initialStudioId: string | undefined, currentUserId: string | undefined) => {
    if (currentUserId && initialStudioId) {
        setDocumenti(currentUserId, initialStudioId)
    }
}

type Token = {
    id: string
    roles: string[]
    studios: Studio[]
}
export const getInitialStudio = (decodedToken: any) => {
    if (decodedToken.roles.includes(USER_ROLE.CONSULENTE_LEGALE)) {
        const prefixedStorage = getLocalStorage();
        const existingStudioId = prefixedStorage.getItem(`last-selected-studio-${decodedToken.id}`);

        if (decodedToken.studios && decodedToken.studios.length > 0) {
            const foundStudio = existingStudioId && existingStudioId !== "undefined"
                ? decodedToken.studios.find((studio: Studio) => studio.id === existingStudioId)
                : null;
            return foundStudio || decodedToken.studios[0];
        }
        return undefined;
    } else if (decodedToken.roles.includes(USER_ROLE.STAFF)) {
        return null;
    }

    return undefined;
};

const prefixedStorage = getLocalStorage();
const rawUserToken = prefixedStorage.getItem('user-info');
const existingUserToken: Token | null = rawUserToken !== null ? JSON.parse(rawUserToken) : null;
export const getUserInitialStudio = (userId?: string | undefined) => {
    if (userId) return getInitialStudio(existingUserToken)
    return undefined
}

const initialState = { studio: existingUserToken !== null ? getUserInitialStudio(existingUserToken.id) : getUserInitialStudio() }

const studioSlice = createSlice({
    name: 'studio',
    initialState,
    reducers: {
        setStudio(state, action) {
            if (action.payload.studio) prefixedStorage.setItem(`last-selected-studio-${action.payload.userId}`, action.payload.studio.id)
            if (action.payload.studio) initializeDocumentsLocalStorage(action.payload.studio.id, action.payload.userId)
            if (action.payload.studio && !action.payload.studio.newui) {
                window.location.replace(
                    '/documenti/produzione?clear_new_ui=true',
                );
            }
            state.studio = action.payload.studio;

        },
    },
});

export const { setStudio } = studioSlice.actions;
const studioReducer = studioSlice.reducer;

export default studioReducer;

